import { APIType, getGraphURL } from 'utils/apiUtils';
import { importWithStaleChunkRecovery } from 'utils/chunkRecoveryUtils';
import { getDeviceInfoHeaders } from 'utils/deviceInfoUtils';
import { authStorage } from 'utils/storage/auth';
import { impersonationStorage } from 'utils/storage/impersonation';
import { localeStorage, timeZoneStorage } from 'utils/storage/intl';

import { logApiError } from './graph/interfaces/apiErrors';

export const getDefaultHeaders = () => {
  const impersonatedUserId = impersonationStorage.get()?.impersonatedUserId;

  return {
    'Accept-Language': localeStorage.get(),
    Authorization: authStorage.get(),
    'Channel-Type': 'WEB',
    'Time-Zone': timeZoneStorage.get(),
    ...(impersonatedUserId && {
      'As-User': impersonatedUserId,
    }),
    ...getDeviceInfoHeaders(),
  };
};

const ApiRequest = async options => {
  const defaultOptions = {
    headers: {
      ...getDefaultHeaders(),
    },
    method: 'POST',
    uri: getGraphURL(APIType.GRAPHQL),
  };

  const requestOptions = { ...defaultOptions, ...options };

  return importWithStaleChunkRecovery(() => import('axios'))
    .then(({ default: axios }) => axios(requestOptions))
    .catch((error: Error) => {
      logApiError(error);
      throw error;
    });
};

export default ApiRequest;
